exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".popComments{width:1000px;max-width:1000px !important}.mr-10{margin-right:10px}.lightgreen{background-color:#f1fff1 !important}.lightyellow{background-color:#fbffe8 !important}.lightred{background-color:#ffe6e6 !important}", ""]);

